import React, { FC } from 'react'
import Icon from 'components/Icon'

type PoweredByLogoType = {
  fill?: string
  fill2?: string
  className?: string
  width: number
  height: number
}

const PoweredByLogo: FC<PoweredByLogoType> = ({
  className,
  fill,
  fill2,
  height,
  width,
}) => {
  return (
    <div className={className}>
      <Icon
        name='powered-by-logo'
        width={width}
        height={height}
        fill={fill || '#42185a'}
        fill2={fill2}
      />
    </div>
  )
}

export default PoweredByLogo
